module.exports = __webpack_public_path__ + "assets/autotest.png?e2ddbe82000563e372693b486604c2a6";